var _path, _rect, _path2, _line, _line2, _line3, _rect2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 82,
    viewBox: "0 0 71 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.626 0.672852H53.4593L70.376 15.6729V69.2462V74.6729H63.126H19.626H12.376V67.2729V8.07285V0.672852H19.626Z",
    stroke: "#BFC3CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.5001,
    y: 28.5,
    width: 23,
    height: 6,
    stroke: "#BFC3CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1459 0.672852V15.962H70.1339",
    stroke: "#BFC3CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29.3639,
    y1: 51.1365,
    x2: 41.2555,
    y2: 51.1365,
    stroke: "#BFC3CE"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 29.3639,
    y1: 40.9443,
    x2: 41.2555,
    y2: 40.9443,
    stroke: "#BFC3CE"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29.3639,
    y1: 46.04,
    x2: 49.7495,
    y2: 46.04,
    stroke: "#BFC3CE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.481934,
    y: 58.4323,
    width: 45,
    height: 23,
    rx: 1,
    fill: "#D8615B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0706 75V66.54H15.7426C16.6706 66.54 17.3866 66.772 17.8906 67.236C18.3946 67.7 18.6466 68.348 18.6466 69.18C18.6466 70.012 18.3946 70.664 17.8906 71.136C17.3866 71.6 16.6706 71.832 15.7426 71.832H13.6066V75H12.0706ZM13.6066 70.62H15.5026C16.6066 70.62 17.1586 70.14 17.1586 69.18C17.1586 68.228 16.6066 67.752 15.5026 67.752H13.6066V70.62ZM19.8987 75V66.54H23.0427C24.4587 66.54 25.5507 66.904 26.3187 67.632C27.0947 68.36 27.4827 69.404 27.4827 70.764C27.4827 72.116 27.0947 73.16 26.3187 73.896C25.5507 74.632 24.4587 75 23.0427 75H19.8987ZM21.4347 73.728H22.9467C24.8987 73.728 25.8747 72.74 25.8747 70.764C25.8747 68.796 24.8987 67.812 22.9467 67.812H21.4347V73.728ZM29.0394 75V66.54H34.5714V67.764H30.5754V70.152H34.3194V71.376H30.5754V75H29.0394Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfThumb);
export default __webpack_public_path__ + "static/media/pdf-thumb.f968e8cd882ec3497b591834a36662f6.svg";
export { ForwardRef as ReactComponent };